import { StripeCardExpiryElementChangeEvent, StripeError } from "@stripe/stripe-js";
import TextField, { TextFieldProps } from "@powerdiary/components-library/lib/components/Controls/TextField";
import { CardExpiryElementProps, CardExpiryElement } from "@stripe/react-stripe-js";
import StripeInput from "../StripeInput";

export type StripeCardExpiryTextFieldProps = { onChange?: (e: StripeCardExpiryElementChangeEvent) => void } & Omit<
    TextFieldProps,
    "onChange"
> &
    CardExpiryElementProps;

export default function StripeCardExpiryTextField({
    children,
    InputProps,
    InputLabelProps,
    size = "medium",
    onChange,
    options,
    onReady,
    ...restProps
}: StripeCardExpiryTextFieldProps) {
    return (
        <TextField
            {...restProps}
            size={size}
            variant="outlined"
            slotProps={{
                input: {
                    ...InputProps,
                    inputComponent: StripeInput,
                    inputProps: {
                        component: CardExpiryElement,
                        options: options,
                        onReady: onReady,
                        onChange: onChange as unknown as TextFieldProps["onChange"],
                        onLoadError: (error: StripeError) => {
                            console.error("Stripe Element failed to load", error);
                        },
                    },
                },
                inputLabel: {
                    ...InputLabelProps,
                    shrink: true,
                },
            }}
        >
            {children}
        </TextField>
    );
}
